/**
 * Hook for updating page title and lang attribute on i18n language change.
 * Fixes P0 #2: <title> toujours FR malgré lang="en"
 */

import { useEffect } from "react";
import { useTranslation } from "react-i18next";

export function usePageTitle() {
  const { i18n } = useTranslation();

  useEffect(() => {
    // Update lang attribute
    document.documentElement.lang = i18n.language.split("-")[0];

    // Update page title dynamically
    const titleMap: Record<string, string> = {
      en: "DooQuest — Build forms and surveys",
      es: "DooQuest — Crea formularios y encuestas",
      fr: "DooQuest — Créez des formulaires et sondages intelligents",
    };

    const lang = i18n.language.split("-")[0];
    document.title = titleMap[lang] || titleMap.en;
  }, [i18n.language]);
}
